import { useState } from 'react';

/**
 * Image d'un choix QCM (réponse), robuste : si la source est vide ou que le
 * chargement échoue, on affiche un placeholder « Image indisponible » à la
 * place — la tuile reste cliquable (la sélection se fait via l'input du label).
 */
function ChoixImageEleve({ src, alt }) {
    const [err, setErr] = useState(false);

    if (!src || err) {
        return (
            <div className="flex flex-col items-center justify-center gap-1 py-4 text-slate-400 select-none pointer-events-none">
                <span className="text-2xl">🖼️</span>
                <span className="text-xs font-medium">Image indisponible</span>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            onError={() => setErr(true)}
            className="max-h-28 sm:max-h-36 w-auto max-w-full object-contain mx-auto pointer-events-none select-none"
        />
    );
}

export default ChoixImageEleve;
